// 📊 장표 컴포넌트 레지스트리 — Overlay169 가 `segment.slide.type` 으로 동적 조회하는 정본.
//   = MSB 디렉터 어휘 9종(LAYOUT_COMPONENTS · EF 카탈로그와 1:1 동기 — tests/msb-catalog-sync)
//   + 클라이언트 전용 확장(kineticTypo — 디렉터가 고르지 않고 브릿지·직접편집만 만든다).
//   ★LAYOUT_COMPONENTS 에 직접 얹지 않는 이유★: 그 맵은 msb-director 가 고를 수 있는 어휘와 같아야
//   한다(카탈로그 동기 테스트). 확장 타입은 EF 무개조로 이 층에서만 산다.
import { LAYOUT_COMPONENTS } from './layouts';
import { KineticTypo } from './kinetic-typo';

export const SLIDE_COMPONENTS = {
  ...LAYOUT_COMPONENTS,
  kineticTypo: KineticTypo,
} as const;

export type SlideComponentId = keyof typeof SLIDE_COMPONENTS;
